<template>
    <div>
        <rkm-form
            ref="Form"
        >
            <rkm-row>

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Detalhes da cota"
                        type="fieldset"
                    >

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="data.form.unidades"
                                    label="Laboratório"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="laboratorio.unidadeId"
                                    disabled
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturasLaboratorio"
                                    textField="nome"
                                    v-model="laboratorio.infraestruturaId"
                                    disabled
                                    valueField="id"
                                    show-default-option

                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="data.form.unidades"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="unidade.unidadeId"
                                    disabled
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    label="Local de atendimento"
                                    :options="infraestruturas"
                                    textField="nome"
                                    v-model="unidade.infraestruturaId"
                                    disabled
                                    valueField="id"
                                    show-default-option
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="3">
                                <rkm-form-input
                                    label="Tipo"
                                    v-model="cota.tipoNome"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    label="Cota"
                                    v-model="cota.cota"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="7">
                                <rkm-form-date-picker
                                    label="Período"
                                    v-model="cota.periodo"
                                    range
                                    disabled
                                />
                            </rkm-col>
                        </rkm-row>

                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            :data="data"
            :unidadeId="unidade.unidadeId"
            :infraestruturaId="unidade.infraestruturaId"
            :laboratorioUnidadeId="laboratorio.unidadeId"
            :laboratorioInfraestruturaId="laboratorio.infraestruturaId"
            :cotaUnidadeSolicitante="cotaUnidadeSolicitante"
            :cota="cota"
            :item="item"
        />

    </div>
</template>

<script>

// Mixins.
import { object, data, formats } from '@/mixins'

// Components.
import List from './List'

// Moment.
import moment from 'moment'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    components: { List },
    computed: {
        infraestruturas() {

            if (this.unidade.unidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.unidade.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        infraestruturasLaboratorio() {

            if (this.laboratorio.unidadeId) {

                let infraestruturaPrincipal = this.data.form.unidades.find(u => u.id === this.laboratorio.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipalLaboratorio(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            index: null,
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaId: null,
            cotaUnidadeSolicitante: false,
            exames: [],
        },
        exames: [],
        enums: {
            tipoUnidade,
            tipoCota
        },
        unidade: {
            id: null,
            cotaId: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaTipoNome: null,
            cotaValor: 0,
            cotaQuantidade: null,
            saldo: '',
            inicio: null,
            fim: null,
        },
        unidadeDestino: {
            id: null,
            unidadeId: null,
            infraestruturaId: null,
            cotaTipoId: null,
            cotaValor: '',
            cotaQuantidade: '',
            inicio: null,
            fim: null,
        },
        laboratorio: {
            unidadeId: null,
            infraestruturaId: null,
        },
        cota: {
            cota: null,
            tipoId: null,
            tipoNome: '',
            periodo: {
                start: null,
                end: null
            },
        },
        cotaUnidadeSolicitante: [],
        checkCotaLaboratorio: false,
        hideUnidadeSolicitante: false,
        unidadeTipoId: null,
    }),
    methods: {
        load() {

            this.model.unidadeDisabled = true
            this.laboratorio.unidadeId = this.unidadeId
            this.laboratorio.infraestruturaId = this.infraestruturaId
            this.unidade.unidadeId = this.item.unidadeSolicitanteId
            this.unidade.infraestruturaId = this.item.infraestruturaSolicitanteId

            const cota = this.data.model.cotasTransferencia.find((obj =>
                obj.laboratorioUnidadeId == this.unidadeId
                && obj.laboratorioInfraestruturaId == this.infraestruturaId
                && obj.origemUnidadeId == this.item.unidadeSolicitanteId
                && obj.origemInfraestruturaId == this.item.infraestruturaSolicitanteId
            ));

            if (cota) {

                this.cotaUnidadeSolicitante = cota.destino
            }

            let cotasLaboratorio = this.data.model.cotasLaboratorio.find((obj =>
                obj.unidadeId == this.unidadeId
                && obj.infraestruturaId == this.infraestruturaId
            ));

            let cotaLaboratorio = cotasLaboratorio.cotaLaboratorio.find((obj =>
                obj.id == this.itemCota.id
            ));

            this.cota.cota = this.item.cota,
            this.cota.tipoId = cotaLaboratorio.cotaTipoId,
            this.cota.tipoNome = cotaLaboratorio.cotaTipoNome,

            this.cota.periodo.start = moment(
                    cotaLaboratorio.periodo.start,
                    'DD/MM/YYYY'
                ).toDate()

                this.cota.periodo.end = moment(
                    cotaLaboratorio.periodo.end,
                    'DD/MM/YYYY'
                ).toDate()

        },
        getPrincipal(infraestruturaPrincipal) {

            this.unidade.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
        getPrincipalLaboratorio(infraestruturaPrincipal) {

            this.laboratorio.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
        },
    },
    mixins: [object, data, formats],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, default: null },
        itemCota: { type: Object, default: null },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
    }
}
</script>